import FactsAndFiguresLegacy from './FactsFiguresLegacy'
import { useLabelsFromAPI } from '@dmi-mch/hooks'
import { getSiteLanguage } from '@utils/storage'

const FactsAndFigures = (props) => {
  const { labels: { AltTags = {} } = {} } = useLabelsFromAPI(['AltTags'], getSiteLanguage())

  return (
    <FactsAndFiguresLegacy {...props} AltTags={AltTags} />
  )
}

export default FactsAndFigures